import { defaultThemeMap } from '@stitches/react';

export const themeMap = {
  ...defaultThemeMap,
};
